import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { LoginContext } from '../../context/loginContext.js';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { isAuthenticated, user } = useContext(LoginContext);

  // Si no está autenticado, redirigir al login
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  // Si hay roles permitidos y el usuario no tiene uno de esos roles, redirigir
  if (allowedRoles.length > 0) {
    const userRole = user.tiu_descripcion || '';
    if (!allowedRoles.includes(userRole.toUpperCase())) {
      return <Navigate to="/login" replace />;
    }
  }

  // Si está autenticado y tiene el rol correcto, renderiza los componentes hijos
  return children;
};

export default ProtectedRoute;

